import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: string | Date): string {
    let datePipe = new Date(value);
    let day = datePipe.getDate();
    let month = datePipe.getMonth();
    let year = datePipe.getFullYear();
    let months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    let mes = months[month];
    const formatYear = `${day}/${mes}/${year}`
    return formatYear;
  }

}

@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeFormatPipe implements PipeTransform {

  transform(value: string | Date): string {
    let datePipe = new Date(value);
    let day = datePipe.getDate();
    let month = datePipe.getMonth();
    let year = datePipe.getFullYear();
    let months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    let mes = months[month];
    const formatTime = `${day}/${mes}/${year} ${datePipe.getHours()}:${datePipe.getMinutes()}`;
    return formatTime;
  }

}
